window.get_lib = (
    open_rdk: boolean,
    name: string, 
    type: string,
) => {
    window.gtag_dwl(name);
    let lib_dir = {
        "robot": "robotlib",
        "tool": "robotlib",
        "station": "library-stations",
        "addin": "library-addins",
        "post": "library-posts",
    };
    let get_lib_func = {
        "robot": "getlib",
        "tool": "gettool",
        "station": "getlib",
        "addin": "getaddin",
        "post": "getpost",
    };
    let fname = encodeURIComponent(name);

    // Open browser link that open RoboDK (app or web)
    if(open_rdk) {
        console.log("Opening robot in RoboDK: " + fname);

        // RoboDK Web
        if(window.Settings.on_robodk_web) {
            if (type == "station"){
                // let lang = window.location.search.split("Lang=")[1] || "";
                // pathname takes care of language!!
                // url 
                // https://web.robodk.com/web?-OpenURL=//web.robodk.com/library-stations/lib/Additive-Manufacturing-and-Machining-with-Mecademic-Meca500-R3.rdk
                // Important: Here we are in an iframe within an iframe! We need the upmost url
                var url = "//" + window.parent.parent.location.hostname + window.parent.parent.location.pathname + "?-OpenURL=//" + window.parent.parent.location.hostname + "/" + lib_dir[type] + "/lib/" + fname;
                window.open(url, '_blank').focus();
            } else {
                window.parent.postMessage({ func: get_lib_func[type], location: lib_dir[type], message: fname }, "*");
            }

        // RoboDK App
        } else {
            window.location.assign(
                "robodk://OpenURL=HTTP__" + window.location.hostname + "/" + lib_dir[type] + "/" + 
                get_lib_func[type] + "?fname=" + fname
            );
        }

    // Download link
    } else {
        window.location.assign(
            "//" + window.location.hostname + "/" + lib_dir[type] + "/" + 
            get_lib_func[type] + "?fname=" + fname
        );
    }
};

window.get_search_params = () => {
    let ret: stringStringMap = {};

    if(window.location.search != "") {
        window.location.search.substring(1).split("&").map((param) => {
            console.log("param", param);
            let splitted_params = param.split("?").map((p) => {
                let temp = p.split("=");
                if (temp[0] == "Lang")
                    ret[temp[0]] = temp[1];

                return p.split("=");
            });
        });
    }

    return ret;
};
